/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CloudProviderEnum } from './cloudProviderEnum';
import { BillingEntityUsageV2 } from './billingEntityUsageV2';
import { VcdsServiceTypeEnum } from './vcdsServiceTypeEnum';
import { AWSRegionsEnum } from './aWSRegionsEnum';


export interface BillingUsageV2 { 
    orgID?: string;
    serviceName?: VcdsServiceTypeEnum;
    cloudProvider?: CloudProviderEnum;
    cloudRegion?: AWSRegionsEnum;
    environment?: string;
    error?: Array<string>;
    reportingEntityUuid?: string;
    reportingEntityVersion?: string;
    reportTime?: string;
    reportingEntityType?: string;
    reportingEntityUsage?: Array<BillingEntityUsageV2>;
}
export namespace BillingUsageV2 {
}


